import { Injectable } from '@angular/core';

/**
 * The single place application logging goes through. Each method forwards to the matching
 * console method with the same arguments, so output is unchanged. Change the sink here
 * (for example a remote log endpoint) rather than at the call sites.
 */
@Injectable({
  providedIn: 'root',
})
export class LoggerService {
  error(...args: unknown[]): void {
    console.error(...args);
  }

  warn(...args: unknown[]): void {
    console.warn(...args);
  }

  info(...args: unknown[]): void {
    console.info(...args);
  }

  debug(...args: unknown[]): void {
    console.debug(...args);
  }

  /** Plain console.log output, kept as its own level so the forwarded output does not change. */
  log(...args: unknown[]): void {
    console.log(...args);
  }
}
